export default "__VITE_ASSET__DjL9meVz__"